// export const BASE_URL = "http://localhost:8086";
// export const DOMAIN = "http://localhost:8086";
export const BASE_URL = "https://crm.raipurhomes.com/rpcrm"; //new post api
export const DOMAIN = "https://crm.raipurhomes.com";
